export enum LlmToolRequestTypes {
  ChatCompletionRequest = 'LlmTool.ChatCompletion.Request',
  ChatCompletionRequestSuccess = 'LlmTool.ChatCompletion.Success',
  ChatCompletionRequestFailure = 'LlmTool.ChatCompletion.Failure',
  SuggestElementLabelSingleRequest = 'LlmTool.SuggestElementLabelSingle.Request',
  SuggestElementLabelSingleRequestSuccess = 'LlmTool.SuggestElementLabelSingle.Success',
  SuggestElementLabelSingleRequestFailure = 'LlmTool.SuggestElementLabelSingle.Failure',
  SuggestEventLabelSingleRequest = 'LlmTool.SuggestEventLabelSingle.Request',
  SuggestEventLabelSingleRequestSuccess = 'LlmTool.SuggestEventLabelSingle.Success',
  SuggestEventLabelSingleRequestFailure = 'LlmTool.SuggestEventLabelSingle.Failure',
  SuggestPageLabelSingleRequest = 'LlmTool.SuggestPageLabelSingle.Request',
  SuggestPageLabelSingleRequestSuccess = 'LlmTool.SuggestPageLabelSingle.Success',
  SuggestPageLabelSingleRequestFailure = 'LlmTool.SuggestPageLabelSingle.Failure',
  SuggestPropertyLabelSingleRequest = 'LlmTool.SuggestPropertyLabelSingle.Request',
  SuggestPropertyLabelSingleRequestSuccess = 'LlmTool.SuggestPropertyLabelSingle.Success',
  SuggestPropertyLabelSingleRequestFailure = 'LlmTool.SuggestPropertyLabelSingle.Failure',
  PrioritizeSelectorComponentsRequest = 'LlmTool.PrioritizeSelectorComponents.Request',
  PrioritizeSelectorComponentsSuccess = 'LlmTool.PrioritizeSelectorComponents.Success',
  PrioritizeSelectorComponentsFailure = 'LlmTool.PrioritizeSelectorComponents.Failure',
  TrimSelectorRequest = 'LlmTool.TrimSelector.Request',
  TrimSelectorSuccess = 'LlmTool.TrimSelector.Success',
  TrimSelectorFailure = 'LlmTool.TrimSelector.Failure',
}

export enum LlmSessionSummaryRequestTypes {
  SessionSummaryRequest = 'LlmSessionSummary.SessionSummary.Request',
  SessionSummaryRequestSuccess = 'LlmSessionSummary.SessionSummary.Success',
  SessionSummaryRequestFailure = 'LlmSessionSummary.SessionSummary.Failure',
}

export enum LlmAutoconfigureRequestTypes {
  KickstartSuggestedElementsRequest = 'LlmAutoconfigure.KickstartSuggestedElements.Request',
  KickstartSuggestedElementsSuccess = 'LlmAutoconfigure.KickstartSuggestedElements.Success',
  KickstartSuggestedElementsFailure = 'LlmAutoconfigure.KickstartSuggestedElements.Failure',
  GetSuggestedGenerationStatusRequest = 'LlmAutoconfigure.GetSuggestedGenerationStatus.Request',
  GetSuggestedGenerationStatusSuccess = 'LlmAutoconfigure.GetSuggestedGenerationStatus.Success',
  GetSuggestedGenerationStatusFailure = 'LlmAutoconfigure.GetSuggestedGenerationStatus.Failure',
}

export enum LlmExperimentsRequestTypes {
  GenerateAssistantRequest = 'LlmExperiments.GenerateAssistant.Request',
  GenerateAssistantRequestSuccess = 'LlmExperiments.GenerateAssistant.Success',
  GenerateAssistantRequestFailure = 'LlmExperiments.GenerateAssistant.Failure',
}

export enum LlmToolTypes {
  GenerateSuggestionsUsed = 'LlmTool.GenerateSuggestionsUsed',
}

export enum AssistantTypes {
  SetSessionContext = 'assistant.setSessionContext',
}
